<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">리더십 역량 진단</div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication37.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">
                #CCL리더십 요소
              </div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              리더십 역랑 진단 : SLCC
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            CCL 연구 결과 기반으로 성공하는 리더가 공통적으로 지닌 주요 역량을
            분석하여 진단 역량 별 행동 가이드과 교육을 제공합니다.
          </div>
          <div class="container_content_text_content">
            내가 보는 나, 타인이 보는 나에 대한 객관적 분석을 통해 리더십을
            진단하고 교육 기획을 설계하는 목적의 진단<br />
            자기인식, 학습민첩성, 영향력, 소통 등 CCL 기반의 4가지 요소를 진단,
            360도 다면 평가<br />
            직무 및 산업군 별 리더십 그룹 리포트 제공 가능, 리더십 보완 요인
            도출로 맞춤 교육 기획 설계 가능. 보완 요인별 강화 워크숍 및 코칭
            진행
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: {Contact},
  name: "Leadershipcompetency",
};
</script>

<style></style>
